import { type Inspection } from './types';

export const FILE_NAME = {
  OBJECT: 'object.glb',
  MANIFEST: 'manifest.json',
  INSPECTION: 'inspection.json',
} as const;

export const FOLDER_NAME = {
  INSPECTIONS: 'inspections',
} as const;

export const CONTENT_TYPE: Record<Inspection.ResourceType, string> = {
  Image: 'image/jpg',
  Pdf: 'application/pdf',
};

const Constants = { FILE_NAME, FOLDER_NAME, CONTENT_TYPE };

export default Constants;
